/**
 * LandingPage — the public marketing page shown to logged-out visitors.
 *
 * Rendered by the route guard (`src/auth/ProtectedRoute.tsx`) whenever there is
 * no session (not loading, no error, no active navigator) IN PLACE of the old
 * auto-redirect to Keycloak. Every call-to-action routes through the same
 * `auth.signinRedirect` / Keycloak-registration flow the guard used, preserving
 * `returnTo` so deep links still land after login.
 *
 * The page is self-contained (no DashboardLayout, no authenticated data hooks),
 * mobile-first responsive, brand-accurate (indigo → violet), dark-mode aware,
 * and honours `prefers-reduced-motion`. It touches nothing in the logged-in app.
 */

import { CTA } from './sections/CTA';
import { FeatureCards3D } from './sections/FeatureCards3D';
import { FeatureGrid } from './sections/FeatureGrid';
import { Footer } from './sections/Footer';
import { Hero } from './sections/Hero';
import { LandingNav } from './sections/LandingNav';
import { Personas } from './sections/Personas';
import { PlansSection } from './sections/PlansSection';
import { Screenshots } from './sections/Screenshots';
import { SocialProof } from './sections/SocialProof';
import { VideoSection } from './sections/VideoSection';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-bg text-foreground">
      {/* Skip link for keyboard / screen-reader users. */}
      <a
        href="#contenu-principal"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-token focus:bg-surface focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-foreground focus:shadow-elevation-2 focus:outline-none focus:ring-2 focus:ring-ring"
      >
        Aller au contenu
      </a>

      <LandingNav />

      <main id="contenu-principal">
        <Hero />
        <FeatureCards3D />
        <FeatureGrid />
        <Screenshots />
        <VideoSection />
        <PlansSection />
        <Personas />
        <SocialProof />
        <CTA />
      </main>

      <Footer />
    </div>
  );
}
